import { Container, Box } from "@mui/material";
import Footer from "./footer";

const PageContainer = ({ children }) => {
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",
                background: "linear-gradient(180deg, #FFFFFF 0%, #FCFCFC 100%)",
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    maxWidth: 1440,
                    flexGrow: 1,
                    px: { xs: 2, md: 4 },
                    py: 6,
                    mx: "auto",
                }}
            >
                {children}
            </Container>

            <Footer />
        </Box>
    );
};

export default PageContainer;
